export default "__VITE_ASSET__M15$sKYV__"